import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { Content } from './styles';
import Header from './Header';

import Box from './Box';
import OpeningBox from './OpeningBox';
import AuditCashier from './AuditCashier';

function CashManagementPage() {
  return (
    <>
      <Header />
      <Content>
        <Switch>
          <Route path="/operation/opening-box" component={OpeningBox} />
          <Route path="/operation/cashier" component={Box} />
          <Route path="/operation/audit-box" component={AuditCashier} />
        </Switch>
      </Content>
    </>
  );
}

export default CashManagementPage;
